import { Component } from '@angular/core';
import { DialogConfig, DialogService } from '@ddt-web/dialog';
import { WwePortfolioPosition } from '@ddt-web/wealth-web';

@Component({
	selector: 'hl-risk-proxy-dialog',
	templateUrl: './risk-proxy-dialog.component.html',
	styleUrls: ['./risk-proxy-dialog.component.scss']
})
export class RiskProxyDialogComponent {

	public portfolios: WwePortfolioPosition[] = [];

	constructor(
		config: DialogConfig,
		private dialogService: DialogService
	) {
		this.portfolios = config.data;
	}

	public close(): void {
		this.dialogService.close();
	}

}
